import { FETCH_STATE_REPORT_REQUEST, FETCH_STATE_REPORT_DATA, FETCH_STATE_REPORT_ERROR, RESET_STATE_REPORT_DATA } from './stateReportTypes';

const initialState = {
  loading: false,
  stateReportData: [],
  error: '',
  error_msg: ''
};

const stateReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STATE_REPORT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case RESET_STATE_REPORT_DATA:
      return {
        ...state,
        stateReportData: []
      };
    case FETCH_STATE_REPORT_DATA:
      return {
        ...state,
        loading: false,
        stateReportData: action.payload
      };
    case FETCH_STATE_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        stateReportData: [],
        error_msg: 'Sorry no data found',
        error: action.payload
      };
    default:
      return state;
  }
};

export default stateReportReducer;
